import * as Yup from 'yup';
import { FormikProvider, useFormik } from "formik";
import ButtonWithLoader from "../../../../../../../common/components/ui/loading/ButtonLoading";
import TextAreaFormik from '../../../../../../../common/components/form/TextAreaFormik';

type Props = {
  paymentId: string;
  renterId: string;
  onClose: () => void;
  onSave: (paymentId: string) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (values: any) => unknown
  reason: string;
}

const validationSchema = Yup.object().shape({
  deletionReason: Yup.string().required('Campo obrigatório')
})

export default function FormDeletePayment(props: Props) {

  const formik = useFormik({
    initialValues: {
      paymentId: props.paymentId,
      deletionReason: '',
      renterId: props.renterId
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const result = await props.onSubmit(values);

        // Verifica se o resultado é um objeto e se tem a propriedade 'ok'
        if (result && typeof result === 'object' && 'ok' in result && result.ok) {
          props.onClose();
        }

        return result;
      } catch (error) {
        console.error("Erro ao processar exclusão:", error);
        return { ok: false, message: "Erro de conexão ao tentar excluir o pagamento" };
      }
    }
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <div className="flex flex-col gap-3">
          <label htmlFor="deletionReason" className="text-sm font-medium text-gray-700">{props.reason}</label>
          <TextAreaFormik
            name="deletionReason"
            placeholder="Descreva abaixo"
          />
        </div>
        <div className="mt-4 flex justify-end gap-3">
          <ButtonWithLoader isLoading={formik.isSubmitting} disabled={!formik.isValid} onClick={formik.handleSubmit}>Salvar</ButtonWithLoader>
        </div>
      </FormikProvider>
    </form>

  )

}